import { addIndex } from '@domain/_screens/overview/campaign-table/utils';
import { CAMPAIGN_TABLE_BUDGET_MANAGER_COLUMNS } from '@shared/constants/dashboard/campaign-table-constants';
import { METRICS_TYPES } from '@shared/constants/MetricsTypeConstants';
import {
    BID_STRATEGY_TYPE, BUDGET, STATUS,
} from '@domain/campaigns/campaign-table/campaign-table.constants';
import { NAME, CLIENT_METRICS, ADVANCED_METRICS } from '@shared/tables';

export const ALL_METRICS = {
    ...addIndex(CAMPAIGN_TABLE_BUDGET_MANAGER_COLUMNS, 0),
    ...addIndex(CLIENT_METRICS, Object.keys(CAMPAIGN_TABLE_BUDGET_MANAGER_COLUMNS).length),
    ...addIndex(ADVANCED_METRICS, Object.keys(CLIENT_METRICS).length),
};

export const FIXED_COLUMNS_CAMPAIGN_TABLE = [
    {
        label: 'Status',
        value: STATUS,
        type: METRICS_TYPES.string,
        isVisibileOnMetricSelector: false,
    },
    {
        label: 'Campaigns',
        value: NAME,
        type: METRICS_TYPES.string,
        isVisibileOnMetricSelector: false,
    },
    {
        label: 'Bid Strategy',
        value: BID_STRATEGY_TYPE,
        type: METRICS_TYPES.string,
        isVisibileOnMetricSelector: false,
    },
    {
        label: 'Daily Budget',
        value: BUDGET,
        type: METRICS_TYPES.integer,
        isVisibileOnMetricSelector: false,
    },
];
